import { helpMessageItemsActions, useSelector } from "inbooma-api";
import React, { useEffect, useState } from "react";
import t from "../../../helpers/t";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";
import FormItem from "../../../components/FormItem";
import ImageUpload from "../../../components/ImageUpload";
import { in_array } from "../../../../utils/Helper";

const EditHelpMessageItem = (props) => {
  const {
    dispatch,
    helpMessage,
    helpMessageItem,
    showNotification,
    setAddHelpMessageItem,
    currentUrl,
    language,
  } = props;
  const _addHelpMessageItem = useSelector(
    (state) => state.help_message_items_data.addHelpMessageItem,
  );
  const _editHelpMessageItem = useSelector(
    (state) => state.help_message_items_data.editHelpMessageItem,
  );
  const [addHelpMessageItemPending, setAddHelpMessageItemPending] = useState(false);
  const [editHelpMessageItemPending, setEditHelpMessageItemPending] = useState(false);
  const [helpMessageItemLocal, setHelpMessageItemLocal] = useState(
    typeof helpMessageItem.id === "undefined"
      ? {
          help_message_id: helpMessage.id,
          position: (helpMessage?.help_message_items?.length || 0) + 1,
          title: null,
          content: null,
          images: [],
          fontSize: 24,
          _translations: {
            en_GB: {
              title: "",
              content: "",
            },
            de_DE: {
              title: "",
              content: "",
            },
          },
        }
      : { ...helpMessageItem, position: Number(helpMessageItem.position) || 1 },
  );
  const [images, setImages] = useState(helpMessageItemLocal.images);
  const [imagesPending, setImagesPending] = useState(false);
  const [image, setImage] = useState(null);

  const itemCount = helpMessage?.help_message_items?.length || 0;
  const ownPosition = Number(helpMessageItemLocal.position) || 0;
  const maxPosition = Math.max(
    itemCount + (typeof helpMessageItemLocal.id === "undefined" ? 1 : 0),
    ownPosition,
    1,
  );
  const positionOptions = [];
  for (let i = 1; i <= maxPosition; i++) {
    positionOptions.push({ id: i, name: String(i) });
  }

  useEffect(() => {
    if (_addHelpMessageItem.success === "" || !addHelpMessageItemPending) return;
    if (_addHelpMessageItem.success === true) {
      showNotification("success", _addHelpMessageItem.data.id);
      exit();
    } else {
      const message = _addHelpMessageItem.data.message;
      if (typeof message === "undefined") {
        showNotification("warning", null, t("help message could not be saved"));
      } else {
        showNotification("warning", null, message);
      }
    }
    setAddHelpMessageItemPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_addHelpMessageItem]);

  useEffect(() => {
    if (image === null || image === "") return;
    let clone = [];
    if (images.length > 0) {
      images.map((img) => {
        if (img.image !== "") {
          clone.push(img);
        }
      });
    }
    clone.push({ image: image });
    setImages(clone);

    setImage(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [image]);

  useEffect(() => {
    if (!imagesPending) return;
    setImagesPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [images, image]);

  useEffect(() => {
    if (_editHelpMessageItem.success === "" || !editHelpMessageItemPending) return;
    if (_editHelpMessageItem.success === true) {
      showNotification("success", _editHelpMessageItem.data.id);
      exit();
    } else {
      const message = _editHelpMessageItem.data.message;
      if (typeof message === "undefined") {
        showNotification("warning", helpMessage.id, t("help message could not be saved"));
      } else {
        showNotification("warning", helpMessage, message);
      }
    }
    setEditHelpMessageItemPending(false);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_editHelpMessageItem]);

  const exit = () => {
    dispatch(helpMessageItemsActions.getHelpMessageItemResetData());
    dispatch(helpMessageItemsActions.getHelpMessageItemsResetData());
    setAddHelpMessageItem(false);
    let returnUrl = `/help_messages${currentUrl.search}`;
    window.location.replace(returnUrl);
  };

  const onChangeField = (e) => {
    const clone = {};
    Object.assign(clone, helpMessageItemLocal);
    const specialFields = ["title_eng", "title_ger", "content_eng", "content_ger", "image"];
    if (!in_array(e.target.name, specialFields)) {
      clone[e.target.name] = e.target.value;
    } else {
      switch (e.target.name) {
        case "title_eng":
          clone._translations["en_GB"].title = e.target.value;
          break;
        case "title_ger":
          clone._translations["de_DE"].title = e.target.value;
          clone.title = e.target.value;

          break;
        case "content_eng":
          clone._translations["en_GB"].content = e.target.value;
          break;
        case "content_ger":
          clone._translations["de_DE"].content = e.target.value;
          clone.content = e.target.value;
          break;
      }
    }
    setHelpMessageItemLocal(clone);
  };

  const onSubmit = () => {
    if (saveDisabled) return;

    const edit = typeof helpMessageItemLocal.id !== "undefined";
    let clone = {};
    Object.assign(clone, helpMessageItemLocal);
    clone.images = images;
    //  delete clone[""];

    if (edit) {
      dispatch(
        helpMessageItemsActions.editHelpMessageItem({
          token: Biscuit.get("token"),
          id: clone.id,
          body: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setEditHelpMessageItemPending(true);
    } else {
      dispatch(
        helpMessageItemsActions.addHelpMessageItem({
          token: Biscuit.get("token"),
          body: clone,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setAddHelpMessageItemPending(true);
    }
  };

  const abortButtonRef = React.createRef();

  // Save is only allowed once all fields have a value
  const translations = helpMessageItemLocal._translations || {};
  const allFieldsFilled =
    translations?.en_GB?.title &&
    translations?.de_DE?.title &&
    translations?.en_GB?.content &&
    translations?.de_DE?.content &&
    helpMessageItemLocal.fontSize &&
    images.length > 0;

  const saveDisabled =
    !allFieldsFilled || addHelpMessageItemPending || editHelpMessageItemPending || imagesPending;

  const deleteImage = (image) => {
    let clone = [];
    if (images.length > 0) {
      images.map((img) => {
        if (img.image !== image) {
          clone.push(img);
        }
      });
    }
    setImages(clone);
  };

  return (
    <>
      <div className="js-off-canvas-overlay is-overlay-fixed is-visible"> </div>

      <div
        className="off-canvas position-right is-transition-overlap is-open"
        id="inb-off-canvas"
        data-off-canvas="85mrb3-off-canvas"
        aria-hidden="false"
      >
        <header className="inb-header off-canvas__header off-canvas--shadow clearfix row">
          <h1 className="inb-page-title">
            {helpMessageItemLocal !== null &&
            helpMessageItemLocal.id !== undefined &&
            helpMessageItemLocal.id !== ""
              ? t("edit_${a}", { a: t("help message item") })
              : t("add_${a}", { a: t("help message item") })}
          </h1>
          <div className="off-canvas__actions column">
            <button
              type="submit"
              className={
                "button medium beautify beautify-" +
                Biscuit.get("user.client_id") +
                " button-submit round"
              }
              title={t("save")}
              onClick={onSubmit}
              disabled={saveDisabled}
            >
              {!addHelpMessageItemPending && !editHelpMessageItemPending && !imagesPending && (
                <>
                  <i className="fi fi-check"> </i>
                  <span>{t("save")}</span>
                </>
              )}
              {(addHelpMessageItemPending || editHelpMessageItemPending || imagesPending) && (
                <span>
                  <img
                    alt="RollingLoader"
                    className="rollingLoader"
                    src={"assets/img/rolling_loader.svg"}
                  />
                  {t("save")}
                </span>
              )}
            </button>
            <a href="#">
              <button
                ref={abortButtonRef}
                type="button"
                id="inb-tasksform-abort-button"
                className="button hollow secondary right button-abort round"
                title={t("close_window")}
                onClick={() => exit()}
              >
                <i className="fi fi-x"> </i>
              </button>
            </a>
          </div>
        </header>
        <p className="off-canvas__subtitle off-canvas__header-region">
          {typeof helpMessageItemLocal.created !== "undefined" &&
            t("created_at") +
              " " +
              moment(helpMessageItemLocal.created).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              helpMessageItemLocal.created_by_name +
              " | " +
              t("last_modified_at") +
              " " +
              moment(helpMessageItemLocal.modified).format("DD.MM.YYYY HH:mm:ss") +
              " " +
              t("edited_by") +
              " " +
              helpMessageItemLocal.modified_by_name}
        </p>
        <form className="off-content row">
          <FormItem
            name="position"
            inputType="select"
            id={
              "help_message_item_position_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            label={t("position", null, "capital")}
            type="select"
            data={positionOptions}
            dataKey="id"
            selected={helpMessageItemLocal.position}
            mediumWidth={6}
            smallWidth={12}
            onChangeHandler={(e, name) =>
              onChangeField({ target: { name, value: e.target.value } })
            }
            labelStyle={{ width: "100%" }}
            extraTopClasses="help_message_item_position_input"
          />
          <FormItem
            name="title_eng"
            inputType="text"
            id={
              "help_message_item_title_eng_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            noIdForName={true}
            label={t("title english", null, "capital")}
            type="input"
            value={helpMessageItemLocal._translations["en_GB"].title}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="help_message_item_title_eng_input"
          />
          <FormItem
            name="title_ger"
            inputType="text"
            id={
              "help_message_item_title_ger_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            label={t("title german", null, "capital")}
            noIdForName={true}
            type="input"
            value={helpMessageItemLocal._translations["de_DE"].title}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="help_message_item_title_ger_input"
          />
          <FormItem
            name="content_eng"
            inputType="text"
            noIdForName={true}
            id={
              "help_message_item_content_eng_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            label={t("content english", null, "capital")}
            type="input"
            value={helpMessageItemLocal._translations["en_GB"].content}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="help_message_item_content_eng_input"
          />
          <FormItem
            name="content_ger"
            inputType="text"
            id={
              "help_message_item_content_ger_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            label={t("content german", null, "capital")}
            noIdForName={true}
            type="input"
            value={helpMessageItemLocal._translations["de_DE"].content}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="help_message_item_content_ger_input"
          />

          <FormItem
            name="fontSize"
            inputType="number"
            id={
              "help_message_item_fontSize_" +
              (typeof helpMessageItemLocal.id !== "undefined" ? helpMessageItemLocal.id : "new")
            }
            label={t("fontSize", null, "capital")}
            noIdForName={true}
            type="input"
            value={helpMessageItemLocal.fontSize}
            mediumWidth={6}
            smallWidth={6}
            onChangeHandler={onChangeField}
            labelStyle={{ width: "100%" }}
            inputStyle={{ width: "100%" }}
            notTiny={true}
            extraTopClasses="help_message_item_fontSize_input"
          />
          {images !== null &&
            images !== "" &&
            images.map((img) => {
              return (
                <>
                  <ImageUpload
                    onChange={onChangeField}
                    image={img.image}
                    type="helpMessageItem"
                    clientId={Biscuit.get("user.client_id")}
                    disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
                    setImage={setImage}
                    multiple={true}
                    dispatch={dispatch}
                    deleteImage={deleteImage}
                    setImagesPending={setImagesPending}
                  />
                </>
              );
            })}
          <ImageUpload
            onChange={onChangeField}
            image={image}
            type="helpMessageItem"
            clientId={Biscuit.get("user.client_id")}
            disabled={Biscuit.get("user.role") === "manager" ? "disabled" : ""}
            setImage={setImage}
            multiple={true}
            dispatch={dispatch}
            setImagesPending={setImagesPending}
          />
        </form>
      </div>
    </>
  );
};

export default EditHelpMessageItem;
